import { useState, useEffect } from 'react';
import { TUILogin } from '@tencentcloud/tui-core';
import { Outlet, useLocation } from 'react-router-dom';
import ChatEngine, { StoreName, TUIStore, TUIConversationService, TUIChatService } from '@tencentcloud/chat-uikit-engine';
import { TUICallKitServer } from '@tencentcloud/call-uikit-react';
import type { ChatSDK } from '@tencentcloud/chat';
import ControllerHeader from '@/layout/ControllerHeader';
import { OutletContextType } from '@/types';
import { loginOverseas, SDKAppID } from '@/api';
import { reportEvent, REPORT_KEY } from '@/utils/aegis';

import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import '@/styles/index.scss';

interface loginInfoParams {
  SDKAppID: number;
  userID: string;
  userSig: string;
  useUploadPlugin?: boolean;
}

export default function AppLayout() {
  const { pathname } = useLocation();
  const [chat, setChat] = useState<ChatSDK>();
  const [env, setEnv] = useState<'web' | 'mobile'>('web');
  const [theme, setTheme] = useState<string>('light');
  const [language, setLanguage] = useState<string>('en-US');
  const [loginUserID, setLoginUserID] = useState<string>('');

  useEffect(() => {
    (async () => {
      const res = await loginOverseas();
      const { userID, userSig } = res.data;
      setLoginUserID(userID);
      init(userID, userSig);
      TUICallKitServer.setLanguage('en');
    })();

    TUIStore.watch(StoreName.APP, {
      tasks: onTasksUpdated,
    });

    return () => {
      TUIStore.unwatch(StoreName.APP, {
        tasks: onTasksUpdated,
      });
    };
  }, []);

  function init(userID: string, userSig: string) {
    const loginInfo: loginInfoParams = {
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
    };
    TUILogin.login(loginInfo).then(() => {
      reportEvent({ actionKey: REPORT_KEY.LOGIN_SUCCESS, fromPath: pathname });
      setChat(TUILogin.getContext().chat);
      createCallRobotConversation(TUILogin.getContext().chat);
    }).catch(() => {
      reportEvent({ actionKey: REPORT_KEY.LOGIN_FAIL, fromPath: pathname });
    });
  }
  async function createCallRobotConversation(chatSDK: ChatSDK) {
    const userID = 'Robot11';
    const conversationID = `C2C${userID}`;
    await TUIConversationService.getConversationProfile(conversationID);
    await TUIChatService.sendTextMessage({
      to: userID,
      conversationType: ChatEngine.TYPES.CONV_C2C,
      payload: {
        text: 'Click the call button in the top right corner to experience it immediately.Let is have a call to discuss where to go next weekend.',
      },
    });
    await chatSDK?.pinConversation({ conversationID, isPinned: true });
    TUIConversationService.switchConversation(conversationID);
  }

  function onTasksUpdated(tasks: Record<string, boolean>) {
    if (tasks.sendMessage) {
      reportEvent({ actionKey: REPORT_KEY.SEND_FIRST_MESSAGE, fromPath: pathname });
    }
  }

  return (
    <div className="iframe-container">
      <ControllerHeader
        env={env}
        theme={theme}
        language={language}
        setEnv={setEnv}
        setTheme={setTheme}
        setLanguage={setLanguage}
      />
      <div className="uikit-container">
        <Outlet context={{ env, theme, language, chat, loginUserID } satisfies OutletContextType} />
      </div>
    </div>
  );
}
